import { useIsDataHomeActive } from './featureChecks'

export default useIsDataHomeActive
